// Cookiefirst
import config from "../config";

export default {

	methods: {
		putCookieFirstScriptInPlace(){
			console.log("--- COOKIEFIRST --------------------------------------");
			console.log("Deploying COOKIEFIRST");
			console.log("-----------------------------------------");
			let script = document.createElement('script');
			script.innerHTML = ``;
			script.setAttribute('src', `https://consent.cookiefirst.com/banner.js`);

			/* Put the code for this action here */
			script.setAttribute('data-cookiefirst-key',`d3765d3f-5ac0-481b-b9cd-e4cf92560d00`);

			document.body.prepend(script);
		}
	},
	beforeMount() {
		if(config.isWebsiteInProduction && !this.isPnGAction){
			this.putCookieFirstScriptInPlace();
		}
	}

}
